import mutations from './exposure.mutations'
import actions from './exposure.actions'
import getters from './exposure.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
